module.exports = __webpack_public_path__ + "static/media/logo.fbdf26df.svg";